/**
* Copyright by:

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { toTitleCase } from '../../../../../../app/shared/functions';
import { Component, Input, OnInit } from '@angular/core';
import { faCheck, faChevronDown, faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import {
  RecordBaseModel,
  WorkflowItemSubtype,
  WorkflowItemType
} from '../../../../../../models/record/record-base.model';
const FINISHED_STRING = $localize`:finished@@finishedTaskChip:Finished`;

@Component({
  selector: 'app-record',
  templateUrl: './record.component.html',
  styleUrls: ['./record.component.scss'],
  standalone: false
})
export class RecordComponent implements OnInit {
  @Input() recordData!: RecordBaseModel[];
  @Input() taskEndTimeStamp!: string | undefined;
  collapsedStates: boolean[] = [];
  FINISHED_STRING = toTitleCase(FINISHED_STRING);
  faChevronDown = faChevronDown;
  faChevronRight = faChevronRight;
  faCheck = faCheck;
  WorkflowItemType = WorkflowItemType;
  WorkflowItemSubtype = WorkflowItemSubtype;
  constructor() {}

  ngOnInit(): void {
    this.collapsedStates = this.recordData?.map(() => false);
  }

  toggleCollapse(index: number) {
    this.collapsedStates[index] = !this.collapsedStates[index];
  }
}
